import React, { Component } from 'react'
import Video from '../video/index.js'
import ReactSwipe from 'react-swipe'
import { SolidBox, Box } from '../icons/index'
import { VideoCount } from '../videoCount/index'
import { Modal } from '../modal/index'
import FullScreen from '../fullscreen/index'
import { BROWSER } from '../../browser-detect'
import './_slider.scss'

class Slider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0,
      showModal: false
    }
  }

  componentDidMount() {
    this.reactSwipe.swipe.stop()
  }

  componentWillMount() {
    const { activeVideo } = this.props
    this.setState({
      active: parseInt(activeVideo)
    })
  }

  handleActiveSlide = e => {
    const { videos } = this.props
    this.setState({
      active: e
    })
    this.setNextVideoAnimation(e)
  }

  setNextVideoAnimation = i => {
    const { videos } = this.props
    const nextIndex = i + 1
    const prevIndex = i - 1 >= 0 ? i - 1 : videos.length
    if (videos[nextIndex]) {
      const formerNextSlides = document.querySelectorAll('.next_slide')
      const nextSlide = document.querySelector(`.video_slide_${nextIndex}`)
      const prevSlide = document.querySelector(`.video_slide_${prevIndex}`)

      if(BROWSER.isExplorer()) {
        for(let i = 0; i < formerNextSlides.length; i++) {
          formerNextSlides[i].classList.remove('next_slide')
        }
      } else {
        formerNextSlides.forEach(slide => {
          slide.classList.remove('next_slide')
        })
      }
      nextSlide.classList.add('next_slide')
    }
  }

  findParent = (el, cls) => {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el
  }

  restorePreviousTitleCard = (fullscreen = false, el, vidParent, poster) => {
    const textContent = el.querySelector('.inner .text_content.animated.slideOutLeft')

    if (textContent && poster) {
      textContent.classList.remove('slideOutLeft')
      poster.classList.remove('animated')
      poster.classList.remove('fadeOutLeft')
      // poster.style.opacity = 1
      // poster.style.position = 'relative'
    }
    if (el && vidParent) {
      vidParent.classList.remove('loaded')
      vidParent.classList.add('not_loaded')
      if (fullscreen === false) {
        el.classList.remove('active_slide')
        el.classList.add('prev_slide')
      }
    }
  }

  stopCurrentlyPlaying = (fullscreen = false) => {
    const currentlyPlayingVideo = document.querySelector('.video.loaded .small_screen_video video')
    const activeSlide = document.querySelector('.active_slide') 
    console.log(activeSlide)
    console.log(currentlyPlayingVideo)
    let vidGrandParent
    let vidParent
  
    if (currentlyPlayingVideo) {
      vidGrandParent = this.findParent(currentlyPlayingVideo, 'active_slide')
      vidParent = this.findParent(currentlyPlayingVideo, 'loaded')
      if (vidGrandParent && vidParent) {
        const poster = document.querySelector('.active_slide img')
        this.restorePreviousTitleCard(fullscreen, vidGrandParent, vidParent, poster)
      }
      currentlyPlayingVideo.pause()
      currentlyPlayingVideo.currentTime = 0
    } else {
      let unloadedVid = document.querySelector('.video.not_loaded')
      vidGrandParent = this.findParent(unloadedVid, 'active_slide')
      vidParent = this.findParent(unloadedVid, 'loaded')
    }
  }

  launchFullScreen = e => {
    this.stopCurrentlyPlaying(true)
    this.setState({
      showModal: true
    })
  }

  handleCloseFullScreen = () => {
    this.setState({
      showModal: false
    })
  }
  videoHasEnded = vidIsOver => {
    const { active } = this.state
    const { videos } = this.props
    const next = active + 1

    if (next < videos.length && vidIsOver) {
      this.slideToSelectedVideo(next)
    }
  }

  slideToSelectedVideo = (i, e) => {
    this.stopCurrentlyPlaying()
    this.reactSwipe.slide(i, 2000)

    const firstSlide = document.querySelector('.video_slide_0')
    const poster = document.querySelector('.video_slide_0 img')
    poster.classList.remove('fadeOutLeft')
    poster.classList.remove('animated')
  }

  render() {
    const { active, showModal } = this.state
    const { videos } = this.props
    const activeVideo = videos[active]
    const VideoNav = (
      <ul className="video_nav">
        {videos.map((video, i) => (
          <li
            key={`video_navKey+${i}`}
            className={i === active ? 'link_active' : ''}
            onClick={this.slideToSelectedVideo.bind(this, i)}>
            {i === active ? <SolidBox /> : <Box />}
          </li>
        ))}
      </ul>
    )
    const _isNext = i => active + 1 === i
    const toggleFullScreen = showModal ? (
      <Modal>
        <FullScreen
          closeFullScreen={this.handleCloseFullScreen}
          videos={videos}
          videoIndex={active}
          video={activeVideo}
        />
      </Modal>
    ) : null

    return (
      <div>
        {toggleFullScreen}
        <div className="slider">
          <VideoCount active={active} videos={videos} />
          <ReactSwipe
            className="video_slider"
            ref={reactSwipe => (this.reactSwipe = reactSwipe)}
            swipeOptions={{
              continuous: false,
              startSlide: active,
              speed: 2000,
              auto: 2000,
              disableScroll: false,
              callback: i => this.handleActiveSlide(i)
            }}>
            {this.props.videos.map((video, i) => (
              <Video
                videos={videos}
                slideIndex={i}
                videoHasEnded={this.videoHasEnded}
                activeIndex={active}
                launchFullScreen={this.launchFullScreen.bind(this, i)}
                isNext={_isNext(i)}
                video={video}
                key={`video_key-${i}`}
              />
            ))}
          </ReactSwipe>
          {VideoNav}
        </div>
      </div>
    )
  }
}
export default Slider



// WEBPACK FOOTER //
// ./src/components/slider/index.js